function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { T, useTranslate } from 'shared/helper/translate';
var Banners = function Banners(_ref) {
  var displayOrderFormBanner = _ref.displayOrderFormBanner,
    displayCheckSpamMessagesBanner = _ref.displayCheckSpamMessagesBanner,
    displayDashboardBanner = _ref.displayDashboardBanner,
    user = _ref.user,
    hideCheckSpamMessageBanner = _ref.hideCheckSpamMessageBanner;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t,
    translationExists = _useTranslate.translationExists;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    checkSpamMessageBannerHidden = _useState2[0],
    setCheckSpamMessageBannerHidden = _useState2[1];
  var handleHideCheckSpamMessageBanner = function handleHideCheckSpamMessageBanner() {
    setCheckSpamMessageBannerHidden(true);
    hideCheckSpamMessageBanner(user.identity);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, displayOrderFormBanner && translationExists('banner-announcements-cart') ? /*#__PURE__*/React.createElement("div", {
    className: "banner-promo"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(T.md, {
    useLink: true,
    source: "banner-announcements-cart"
  }))) : null, displayDashboardBanner && translationExists('banner-announcements-dashboard') ? /*#__PURE__*/React.createElement("div", {
    className: "banner-promo"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(T.md, {
    useLink: true,
    source: "banner-announcements-dashboard"
  }))) : null, displayCheckSpamMessagesBanner && !checkSpamMessageBannerHidden ? /*#__PURE__*/React.createElement("div", {
    className: "banner-promo"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": t('Dismiss message'),
    type: "button",
    className: "float-end pt-3 pe-2",
    onClick: handleHideCheckSpamMessageBanner
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-circle-xmark"
  })), /*#__PURE__*/React.createElement(T.md, {
    source: "check-spam-message-text",
    params: user.email
  }))) : null);
};
export default Banners;